/* eslint-disable import/prefer-default-export */
import { createSelector } from "reselect";

const notificationsState = (state) => state.notifications;

export const selectNotifications = createSelector(notificationsState, (notifications) => notifications.all.items);
